module.exports = __webpack_public_path__ + "img/Demcompression_Single_Frame0001.fd69f9a2.jpg";